import PortfolioAutoTradeDetailOrderType from './PortfolioAutoTradeDetailOrderType';

export default PortfolioAutoTradeDetailOrderType;
